import { compose } from "redux";
import React, { PureComponent } from "react";
import { Grid, Box } from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";

import { ReportHeaderBase, ReportHeaderIconButton } from "altus-ui-components";

import reportService from "services/report.service";
import LoadingButton from "app/components/LoadingButton";

class POBReportHeader extends PureComponent {
  render() {
    return (
      <Box displayPrint="none">
        <ReportHeaderBase>
          <Grid xs item container spacing={2} wrap="nowrap" alignItems="center">
            <Grid item xs />
            <Grid item>
              <ReportHeaderIconButton
                title="Print"
                onClick={window.print}
                Icon={PrintIcon}
              />
            </Grid>
            <Grid item>
              <LoadingButton
                size="medium"
                type="submit"
                variant="contained"
                onClick={reportService.previewPOBReport}
              >
                Download
              </LoadingButton>
            </Grid>
          </Grid>
        </ReportHeaderBase>
      </Box>
    );
  }
}

export default compose()(POBReportHeader);
